import { SCFileResponse } from "entities/UIModel/SCFileResponse";

export const isSCFileResponse = (
  option: SCFileResponse | string
): option is SCFileResponse =>
  (option as SCFileResponse).clientFileId !== undefined;
